import React from 'react';
import './Footer.css';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn } from 'react-icons/fa';


const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-brand footer-brand-left">
        <h3>IMAGE TECHNOLOGY</h3>
      </div>
      <div className="footer-contact-center">
        <a href="mailto:info@imagetechnology.in" className="footer-contact-link">info@imagetechnology.in</a>
        <span className="footer-contact-separator">|</span>
        <a href="tel:+917710051373" className="footer-contact-link">+91 7710051373</a>
      </div>
      <div className="footer-social-right">
        <a href="https://facebook.com/" className="footer-social-icon" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <FaFacebookF />
        </a>
        <a href="https://instagram.com/" className="footer-social-icon" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <FaInstagram />
        </a>
        <a href="https://linkedin.com/" className="footer-social-icon" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
          <FaLinkedinIn />
        </a>
      </div>
      <div className="footer-bottom">
        <div className="footer-bottom-container">
          <p>&copy; 2024 Image Technology. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 